"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KNOWN_BOOTLOADERS = exports.SENSOR_OTA_ACTIVE_STATUSES = exports.SensorType = exports.SensorStatus = void 0;
var SensorStatus;
(function (SensorStatus) {
    /**
     * Scanned (or hand-entered) but not yet handed to the base station. The row
     * exists so an installer can walk away and come back to it; the DSK is not
     * armed in SmartStart until `beginSensorInclusion` flips this to PENDING, so
     * a draft occupies nothing on the hub. Installer-only: hidden from homeowner
     * surfaces, skipped by the status sweep, never alerts.
     */
    SensorStatus["Draft"] = "DRAFT";
    SensorStatus["Active"] = "ACTIVE";
    SensorStatus["Inactive"] = "INACTIVE";
    SensorStatus["Maintenance"] = "MAINTENANCE";
    SensorStatus["Pending"] = "PENDING";
    SensorStatus["Pairing"] = "PAIRING";
    SensorStatus["PairingFailed"] = "PAIRING_FAILED";
    SensorStatus["PairedAwaitingData"] = "PAIRED_AWAITING_DATA";
})(SensorStatus = exports.SensorStatus || (exports.SensorStatus = {}));
var SensorType;
(function (SensorType) {
    SensorType["AIR_QUALITY"] = "AIR_QUALITY";
    SensorType["CO2"] = "CO2";
    SensorType["ELECTRICAL"] = "ELECTRICAL";
    SensorType["HUMIDITY"] = "HUMIDITY";
    SensorType["HVAC_CONDENSER_MONITOR"] = "HVAC_CONDENSER_MONITOR";
    SensorType["HVAC_AIRHANDLER_MONITOR"] = "HVAC_AIRHANDLER_MONITOR";
    SensorType["LEAK_DETECTOR"] = "LEAK_DETECTOR";
    SensorType["LIGHT"] = "LIGHT";
    SensorType["PM10"] = "PM10";
    SensorType["PM25"] = "PM25";
    SensorType["POWER"] = "POWER_MONITOR";
    SensorType["POWER_ALT"] = "POWER";
    SensorType["PRESSURE"] = "PRESSURE";
    SensorType["TEMPERATURE"] = "TEMPERATURE";
    SensorType["VOC"] = "VOC";
    SensorType["WATER_QUALITY"] = "WATER_QUALITY";
    SensorType["MOTION"] = "MOTION";
    SensorType["OTHER"] = "OTHER";
    // CT sensors are used to measure current transformer values
    SensorType["HVAC_CONDENSER_MONITOR_CT"] = "HVAC_CONDENSER_MONITOR_CT";
    SensorType["HVAC_AIRHANDLER_MONITOR_CT"] = "HVAC_AIRHANDLER_MONITOR_CT";
    // legacy alias for HVAC_AIRHANDLER_MONITOR
    SensorType["HVAC"] = "HVAC_AIRHANDLER_MONITOR";
})(SensorType = exports.SensorType || (exports.SensorType = {}));
/** Statuses during which an update is still in flight. */
exports.SENSOR_OTA_ACTIVE_STATUSES = [
    'queued',
    'starting',
    'downloading',
    'installing',
];
/**
 * Bootloader builds by `Sensor.bootloaderFingerprint`: the first 8 bytes of
 * SHA-256 over sensor flash 0x08000000..0x08006000, as lowercase hex. Adding a
 * build is one line.
 */
exports.KNOWN_BOOTLOADERS = {
    // PC01 release-folder SPI bootloader.
    bd16d101b188f224: 'SPI Bootloader',
};
